import { Card } from "@mui/material";
import { DateTime } from "luxon";
import { Zone, TerrorZoneLabels } from "@tt/common";
import { VoucherList } from "./vouchers";

export const ZoneList = (props: {zones: Array<Zone>}) => (
  <>
    {props.zones.map(zone => (
      <Card variant='outlined' key={zone.name} className='zone-card'>
        {zone.utcTimestamp && <h4>
            {DateTime.fromISO(zone.utcTimestamp).toLocaleString(DateTime.DATETIME_MED)}
            {' - '} 
            {DateTime.fromISO(zone.utcTimestamp).plus({hours: 1}).toLocaleString(DateTime.TIME_SIMPLE)}
        </h4>}
        <h2>{TerrorZoneLabels[zone.name]}</h2>
        <VoucherList {...zone} />
      </Card>
    ))}
  </>
)